import styled from 'styled-components/macro';
import { ContainerStyled } from '@yme/atoms/grid';
import { Link } from '@yme/components/Link';
import { colorCoreGray700, colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { ADAPTIVE, mediaQuery } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel1, HeadingLevel4 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { getTextStyles, transformSrcSetToCss } from '@yme/utils/styles';
export const HeroBannerStyled = styled.div `
  position: relative;
  width: 100%;
  background-color: ${colorCoreGray700};
  aspect-ratio: ${AspectRatio.RectangleLevel3};

  ${ADAPTIVE.minWidth.desktop} {
    min-height: 405px;
    max-height: 810px;
    max-width: 1920px;
    margin: 0 auto;
  }

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const HeroImageStyled = styled.div `
  box-sizing: border-box;
  position: relative;
  overflow-wrap: break-word;
  height: 100%;
  width: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    //safari fix
    max-height: 810px;
  }

  ${({ srcSet, imageUrl }) => transformSrcSetToCss(srcSet, imageUrl, HERO_SECTION_BACKGROUND_SECOND)}

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${ContainerStyled} {
    ${ADAPTIVE.maxWidth.mobile} {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;
export const BodyTextStyled = styled.div `
  ${({ isResetPadding }) => !isResetPadding && 'margin-top: 16px;'}

  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreWhite1000};
  overflow: hidden;

  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles('Ubuntu', 400, 14, 20)}
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }
`;
export const HeadingLevel1Clamp = styled(HeadingLevel1) `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${mediaQuery(null, '16:9', `-webkit-line-clamp: 2;`)};
  ${mediaQuery('21:9', '32:9', `-webkit-line-clamp: 2;`)};
  ${mediaQuery('32:9', null, `-webkit-line-clamp: 2;`)};

  @media (max-width: 768px) {
    width: 100%;
    -webkit-line-clamp: inherit; // adjust this as per your requirement
  }
`;
export const BodyTextStyledClamp = styled(BodyTextStyled) `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${mediaQuery(null, '16:9', `-webkit-line-clamp: 6;`)};
  ${mediaQuery('21:9', '32:9', `-webkit-line-clamp: 4;`)};
  ${mediaQuery('32:9', null, `-webkit-line-clamp: 4;`)};

  @media (max-width: 768px) {
    width: 100%;
    -webkit-line-clamp: inherit;
  }
`;
export const SubtitleStyled = styled(HeadingLevel4) `
  margin-bottom: 4px;
`;
export const HeroSectionThemeStyled = styled.div `
  padding: ${INDENT.sm} 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
export const ButtonsSectionStyled = styled.div `
  ${({ isResetPadding }) => !isResetPadding && 'margin-top: 24px;'}

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
  }
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
